import sessionService from '_services/common/sessionService';

export default (to, from, next) => {
  const id = Number(sessionService.getCookie('_id'));
  const user = sessionService.getLocalData('_user');

  if (id && id === user.id) {
    next();
  } else {
    next(`/login?redirect=${to.fullPath}`);
  }
};
